"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Binding_1 = require("./Binding");
class Instance extends Binding_1.Binding {
    /**
     * Resolve and return the value of the binding.
     *
     * @return {any}
     */
    resolve() {
        return this.value;
    }
}
exports.Instance = Instance;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5zdGFuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYmluZGluZ3MvSW5zdGFuY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx1Q0FBbUM7QUFHbkMsTUFBYSxRQUFTLFNBQVEsaUJBQU87SUFDbkM7Ozs7T0FJRztJQUNJLE9BQU87UUFDWixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUE7SUFDbkIsQ0FBQztDQUNGO0FBVEQsNEJBU0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBCaW5kaW5nIH0gZnJvbSAnLi9CaW5kaW5nJ1xuaW1wb3J0IHsgSW5zdGFuY2VJbnRlcmZhY2UgfSBmcm9tICcuLi9pbnRlcmZhY2VzL2JpbmRpbmdzL0luc3RhbmNlSW50ZXJmYWNlJ1xuXG5leHBvcnQgY2xhc3MgSW5zdGFuY2UgZXh0ZW5kcyBCaW5kaW5nIGltcGxlbWVudHMgSW5zdGFuY2VJbnRlcmZhY2Uge1xuICAvKipcbiAgICogUmVzb2x2ZSBhbmQgcmV0dXJuIHRoZSB2YWx1ZSBvZiB0aGUgYmluZGluZy5cbiAgICpcbiAgICogQHJldHVybiB7YW55fVxuICAgKi9cbiAgcHVibGljIHJlc29sdmUgKCk6IGFueSB7XG4gICAgcmV0dXJuIHRoaXMudmFsdWVcbiAgfVxufVxuIl19